/**
 * @chineseName 骨架屏
 * @subDescription m-ui组件 骨架屏
 */
import Skeleton from './Skeleton';
export default Skeleton;